import {
  SET_TRANSACTIONS_COUNT
} from "./constants";

export const setTransactionsCount = (totalCount: number) =>
  ({
    type: SET_TRANSACTIONS_COUNT,
    payload: totalCount,
  } as const);
